// removed by extract-text-webpack-plugin
module.exports = {"faqContainer":"faqContainer__35eUs","innerFaqContainer":"innerFaqContainer__3yj5m","faqHeader":"faqHeader__3DXKw","faqHeaderText":"faqHeaderText__zRkZe","innerSection":"innerSection__3omxG","faqsContainer":"faqsContainer__1NmXL","eachFaqContainer":"eachFaqContainer__NmMu2","faqQuestion":"faqQuestion__JHKI2","faqAnswer":"faqAnswer__2qrGr","expandedSymbol":"expandedSymbol__1V7i5","collapedSymbol":"collapedSymbol__3gX-d"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/faq/style.css
// module id = 7s3x
// module chunks = 459